'use strict';

export default class IconController {

  /*@ngInject*/
  constructor($http, $state, $stateParams, $scope, toaster, Upload) {
    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$scope = $scope;
    this.toaster = toaster;
    this.Upload = Upload;
  }

  $onInit() {
    this.$scope.$watch('asEditCtrl.file', (file) => {
      if (file !== undefined && file !== null) {
        this.uploadIcon(file);
      }
    });

    this.$scope.$watch('asEditCtrl.colorFile', (file) => {
      if (file !== undefined && file !== null) {
        this.uploadColorIcon(file);
      }
    });

    this.$scope.$watch('asEditCtrl.bannerFile', (file) => {
      if (file !== undefined && file !== null) {
        this.uploadBanner(file);
      }
    });

    this.$scope.$watch('asEditCtrl.apk', (file) => {
      if (file !== undefined && file !== null) {
        this.uploadApk(file);
      }
    });

    this.getCategories();
    this.getList();
    this.getTags()
  }

  getApp() {
    this.$http.get('/api/apks/' + this.$stateParams.id).then(response => {
      this.app = response.data;
      this.app.index = !!this.app.index
      this.app.recommend = !!this.app.recommend
      this.app.tags = this.app.tags.map(item => {
        return item._id
      })
    });
  }

  uploadIcon(file) {
    this.toaster.pop({
      type: 'wait',
      title: '正在上传图标，请稍等...',
      body: file.name,
      timeout: 3000 * 1000
    });

    file.upload = this.Upload.upload({
      url: `/api/apks/${this.app._id}/uploadIcon`,
      file: file,
      data: this.app,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });

    file.upload.progress((evt) => {
      file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
    });

    file.upload.success((data, status, headers, config) => {
      this.toaster.clear();
      this.getApp();
      this.toaster.pop('success', '上传成功', file.name);
    });

    file.upload.error((err) => {
      this.toaster.clear();
      this.toaster.pop('error', '上传失败', JSON.stringify(err));
    });
  }

  uploadColorIcon(file) {
    this.toaster.pop({
      type: 'wait',
      title: '正在上传图标，请稍等...',
      body: file.name,
      timeout: 3000 * 1000
    });

    file.upload = this.Upload.upload({
      url: `/api/apks/${this.app._id}/uploadColorIcon`,
      file: file,
      data: this.app,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });

    file.upload.progress((evt) => {
      file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
    });

    file.upload.success((data, status, headers, config) => {
      this.toaster.clear();
      this.getApp();
      this.toaster.pop('success', '上传成功', file.name);
    });

    file.upload.error((err) => {
      this.toaster.clear();
      this.toaster.pop('error', '上传失败', JSON.stringify(err));
    });
  }

  uploadBanner(file) {
    this.toaster.pop({
      type: 'wait',
      title: '正在上传图，请稍等...',
      body: file.name,
      timeout: 3000 * 1000
    });

    file.upload = this.Upload.upload({
      url: `/api/apks/${this.app._id}/uploadBanner`,
      file: file,
      data: this.app,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });

    file.upload.progress((evt) => {
      file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
    });

    file.upload.success((data, status, headers, config) => {
      this.toaster.clear();
      this.getApp();
      this.toaster.pop('success', '上传成功', file.name);
    });

    file.upload.error((err) => {
      this.toaster.clear();
      this.toaster.pop('error', '上传失败', JSON.stringify(err));
    });
  }

  update() {
    this.$http.put(`api/apks/${this.app._id}`, this.app).then(response => {
      this.$state.go('appstore');
    });
  }

  getCategories() {
    this.$http.get('/api/categories/appForWeb').then(res => {
      this.categories = res.data.children;
      this.getApp();
    })
  }

  uploadApk(file) {
    this.toaster.pop({
      type: 'wait',
      title: '正在上传APK，请稍等...',
      body: file.name,
      timeout: 3000 * 1000
    });

    file.upload = this.Upload.upload({
        url: `/api/apks/${this.app._id}/updateApk`,
        file: file,
        data: this.app,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
    });

    file.upload.progress((evt) => {
      file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
    });

    file.upload.success((data, status, headers, config) => {
      this.toaster.clear();
      this.getApp();
      this.toaster.pop('success', '上传成功', file.name);
    });

    file.upload.error((err) => {
      this.toaster.clear();
      this.toaster.pop('error', '上传失败', JSON.stringify(err));
    });
  }

  getList() {
    this.$http.get('/api/AppConfGroups').then(res => {
      this.groups = res.data;
    });
  }

  getTags() {
    this.$http.get('/api/tags', {  }).then(response => {
      this.tags = response.data;
    });
  }

  toggleSelection(id) {
    let idx = this.app.modelGroups.indexOf(id);
    if (idx > -1) {
      this.app.modelGroups.splice(idx, 1);
    } else {
      this.app.modelGroups.push(id);
    }
  }

  toggleTagSelection(id) {
    let idx = this.app.tags.indexOf(id);
    if (idx > -1) {
      this.app.tags.splice(idx, 1);
    } else {
      this.app.tags.push(id);
    }
  }

  toggleCategorySelection(id) {
    let idx = this.app.category.indexOf(id);
    if (idx > -1) {
      this.app.category.splice(idx, 1);
    } else {
      this.app.category.push(id);
    }
  }

}



// WEBPACK FOOTER //
// ./client/app/appstore/edit/edit.controller.js